import { Grid, Typography, Box, CircularProgress } from '@mui/material';
import ReactEcharts from "echarts-for-react";
import { handleLanguageChange, lang } from '../../utils/multiLangDashboardV2Data';
import { QueryRenderer } from '@cubejs-client/react'
import { url } from '../../config/urls'
import cubejs from '@cubejs-client/core'
import settings from "../../config/settings";
import { DecryptData } from "../../utils/encryptDecrypt";
import {Skeleton} from '@mui/material';


import _ from 'lodash';
import { isMobileView } from '../../utils/Reusables';
const statsCardClasses = ["first", "second", "third", "fourth"]
const API_URL = url.cubeApiUrl
const CUBE_PUBLISHED_URL = url.cubePublishedApiUrl

const formatCustomData = (data) => {
    data.forEach(ele => {
        if (Object.keys(ele).length) {
            Object.keys(ele).forEach(k => {
                if (!ele[k]) {
                    ele[k] = 0
                }
            })
        }
    })
    return data
}

const formatStudentReportQuery = (studentId,query) => {
    if(studentId && query) {
            let dataSetName = null;
            if (query?.dimensions?.length > 0) {
                dataSetName = query.dimensions[0]?.split('.')[0];
            }
            else if (query?.measures?.length > 0) {
                dataSetName = query.measures[0]?.split('.')[0];
            }
            
            if(query?.filters?.length ) {
                let ifExist = query?.filters?.find(f => f?.member.includes('sUuid'))
                if(ifExist) {
                    ifExist.values = [studentId]
                }
                else {
                      query?.filters.push({
                          member : `${dataSetName}.sUuid`,
                          operator: 'equals',
                          values: [studentId]
                      })

                }
            }
            else {
                query?.filters.push({
                          member : `${dataSetName}.sUuid`,
                          operator: 'equals',
                          values: [studentId]
                })
            }
            query = formatQueryFilter(query)
            return query
    }
    query = formatQueryFilter(query)
    return query
}

const formatQueryFilter = (query) => {
    if(query?.filters?.length ) {
        query?.filters?.map(f => {
            if(f?.values && typeof f?.values[0] === 'number') {
                f.values = f?.values?.map(v => v?.toString())
            }
        })
    }
    return query
 }

const circularProgressOption = (data) => ({
    series: [
        {
            type: "gauge",
            smooth: true,
            radius: "100%",
            startAngle: 90,
            endAngle: -270,
            center: ["50%", "50%"],
            min: 0,
            max: 100,
            itemStyle: {
                color: "#fff"
            },
            progress: {
                show: true,
                roundCap: true,
                width: 5
            },
            pointer: {
                show: false
            },
            axisLine: {
                show: true,
                lineStyle: {
                    width: 5,
                    color: [[1, '#fff']],
                    opacity: 0.5
                }
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                show: false
            },
            title: {
                show: false,
                width: 90,
                offsetCenter: ["75", "-10"],
                overflow: "break"
            },
            detail: {
                offsetCenter: [0, 0],
                lineHeight: 16,
                valueAnimation: true,
                color: "#fff",
                fontSize: isMobileView() ? "18px" : "24px",
                formatter: function (v) {
                    return [v, "%"].join("");
                },
                rich: {
                    score: {
                        color: "#fff",
                        fontSize: 12
                    },
                    status: {
                        color: "#fff",
                        fontSize: 12
                    }
                }
            },
            data
        }
    ]
});

let language = DecryptData(localStorage.getItem("lang"))


const PerformanceCard = (props) => {
    let cubejsApi = ""
    const CUBE_TOKEN = localStorage.getItem('cubeToken')
    if (CUBE_TOKEN)
        cubejsApi = cubejs(CUBE_TOKEN, { apiUrl: `${CUBE_PUBLISHED_URL}/cubejs-api/v1` })

    let { item, index, selectedProfile, profileReportIds, studentId } = props
    let { highestPerform, leastPerform, Accuracy_Perc, overAllAtten } = settings?.STUDENT_DASHBOARD_CALCULATED_FIELDS ?? {}
    let performanceKey = ''
    let statsTitle = ''
    switch (item?.title) {
        case 'High Performing':
            statsTitle = 'Area of Strength'
            performanceKey = highestPerform
            // if(language=== 'parent_hi' || language=== 'parent_en') 
            //     item.query.filters.push({"member":"StudentAssessmentSummary.MMcOi1645619294448","operator":"gt","values":["75"]})
            break;
        case 'Least Performing':
            statsTitle = 'Area of Improvement'
            performanceKey = leastPerform
            // if(language=== 'parent_hi' || language=== 'parent_en') 
            //     item.query.filters.push({"member":"StudentAssessmentSummary.MMcOi1645619294448","operator":"lt","values":["60"]})
            break;
        case 'Overall Accuracy':
            statsTitle = 'Overall-Acc'
            statsTitle = lang === 'en' ? statsTitle.replace('-Acc', '') : statsTitle
            performanceKey = Accuracy_Perc
            break;
        case 'Overall Attendance':
            statsTitle = 'Overall'
            performanceKey = overAllAtten
            break;
    }

    if (selectedProfile?.length && profileReportIds?.length) {
        if (!profileReportIds?.includes(item?.title)) {
            return null
        }
    }


    let formattedQuery = _.cloneDeep(formatStudentReportQuery(studentId,item?.query))
    return (
        <div key={index} className={"er-stats-card " + statsCardClasses[index]} >
            <Grid className="er-stats-card-grid"  >

                    {
                    formattedQuery ?
                    <QueryRenderer
                        query={formattedQuery}
                        cubejsApi={cubejsApi}
                        render={({ resultSet, loadingState }) => {
                            if (loadingState?.isLoading) {
                                //return <Box className="width-100" display="flex" justifyContent="center" alignItems="center"> <CircularProgress className='cm_white_txt'/></Box>
                                return <Box className="width-100"> 
                                            <Skeleton className='progress-skeleton white' animation="wave" />
                                            <Skeleton className='progress-skeleton white half' animation="wave" />
                                        </Box>
                            }
                             let data1 = resultSet?.loadResponse?.results?.[0]?.data
                            let dataDisplay = 0
                            let dataLabel = item?.label
                            if (data1?.length) {
                                data1 = formatCustomData(data1)

                                const perfData = data1.filter(d => d &&  !isNaN(d[performanceKey]))?.[0]
                                if (perfData) {
                                    dataDisplay = Math.round(perfData[performanceKey], 2)
                                    if(item?.query?.dimensions?.length && data1[0][item?.query?.dimensions[0]]) {
                                       dataLabel =  data1[0][item?.query?.dimensions[0]]
                                    }
                                }
                            }

                         return <>
                            <Box className="er-stats-card-grid-chart"  >
                                 <ReactEcharts option={circularProgressOption([dataDisplay])} style={{ height: (isMobileView() ? "100px" : "100px"), width: (isMobileView() ? "100px" : "100px") }} opts={{ renderer: 'svg' }} />
                            </Box>
                            <Box  className="er-stats-card-grid-content"  >
                                <Box>
                                    <Typography variant="body2" className="er-stats-card-title">{handleLanguageChange(statsTitle)}</Typography>
                                    <Typography variant="body2" className="er-stats-card-subtitle">{handleLanguageChange(dataLabel)}</Typography>
                                </Box>
                             </Box>

                             </>
                            }}

            /> : null
            }
            </Grid>
        </div >)
}

export default PerformanceCard
